import { Component, ElementRef, Input, NgZone, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CdkDragMove } from '@angular/cdk/drag-drop';
import { MatBottomSheetRef } from '@angular/material';

@Component({
  selector: 'app-bottom-popup',
  templateUrl: 'bottom-popup.component.html',
  styleUrls: ['bottom-popup.component.scss']
})
export class BottomPopupComponent {

  @Input() mbsRefference: MatBottomSheetRef;

  @ViewChild('childTemplate') childTemplate: TemplateRef<any> | undefined;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @ViewChild('resizeBox') resizeBox: ElementRef;
  @ViewChild('dragHandleTop') dragHandleTop: ElementRef;

  @Input() headerText: any;
  @Input() height: number;
  @Input() maxHeight: number;
  @Input() minHeight: number;

  get getMaxHeight(): number{
    if(this.maxHeight){
      return this.maxHeight;
    }else{
      return window.innerHeight * 0.75;
    }

  }

  get resizeBoxElement(): HTMLElement {
    return this.resizeBox.nativeElement;
  }

  get dragHandleTopElement(): HTMLElement {
    return this.dragHandleTop.nativeElement;
  }
  dragMove($event: CdkDragMove<any>) {
    this.resize($event.pointerPosition.y);
  }

  resize(pointerPostitionY: number) {
    const resizeBoxRect = this.resizeBoxElement.getBoundingClientRect();
    if(!this.height){
      this.height = resizeBoxRect.height;
    }
    const fromTopOfDraggedElement = pointerPostitionY - resizeBoxRect.top;
    this.height = this.height - fromTopOfDraggedElement;

    if (this.getMaxHeight <= this.height) {
      this.height = this.getMaxHeight;
    }
    if (this.minHeight >= this.height) {
      this.height = this.minHeight;
    }
    this.resizeBoxElement.style.height = this.height + 'px';

    this.setHandleTransform(this.dragHandleTopElement);
  }

  setHandleTransform(
    dragHandle: HTMLElement
  ) {
    const translateY = 0;
    dragHandle.style.transform = `translate(0, ${translateY}px)`;
  }

  close(){
    this.mbsRefference.dismiss();
  }
}

